export const decodeJwt = (token: string): Record<string, any> | null => {
    try {
        const payload = token.split('.')[1];
        const decodedPayload = window.atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(decodedPayload);
    } catch (error) {
        console.error('Error decoding JWT:', error);
        return null;
    }
};

export const getTokenExpiration = (token: string): number | null => {
    const decoded = decodeJwt(token);
    return decoded?.exp ?? null;
};

export const isTokenExpired = (token: string): boolean => {
    const exp = getTokenExpiration(token);
    if (!exp) return true;

    const now = Date.now() / 1000;
    return now >= exp;
};

export const isAccessTokenExpired = (accessToken: string): boolean => {
    return isTokenExpired(accessToken);
};

export const isRefreshTokenExpired = (refreshToken: string): boolean => {
    return isTokenExpired(refreshToken);
};
